"use client";

import dynamic from "next/dynamic";

const PostHogPageViewTracker = dynamic(
  () => import("@/components/analytics/PostHogPageViewTracker"),
  { ssr: false },
);

export default function LazyPostHogPageViewTracker() {
  return <PostHogPageViewTracker />;
}
